"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComboboxItemsLoader = void 0;
var react_1 = require("react");
var util_1 = require("../../util");
function useComboboxItemsLoader(items, debounceMs) {
    if (debounceMs === void 0) { debounceMs = 350; }
    var _a = react_1.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = react_1.useState([]), currItems = _b[0], setCurrItems = _b[1];
    var load = react_1.useCallback(function (filter) {
        setLoading(true);
        Promise.resolve(items(filter))
            .then(setCurrItems)
            .finally(function () { return setLoading(false); });
    }, [items]);
    var debouncedLoad = react_1.useMemo(function () { return util_1.debounce(load, debounceMs); }, [load, debounceMs]);
    var loadItems = react_1.useCallback(function (filter) { return debouncedLoad(filter); }, [debouncedLoad]);
    return {
        items: currItems,
        loading: loading,
        loadItems: loadItems,
    };
}
exports.useComboboxItemsLoader = useComboboxItemsLoader;
//# sourceMappingURL=useComboboxItemsLoader.js.map